<template>
    <split-pane  :min-percent='10' :default-percent='12' split="vertical" style="background:white; height:100%">
        <template slot="paneL">
            <el-tree :data="orgData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"                       
                        :style="{height: scrollerHeight,overflow:'auto',display: 'flex',padding:15}"
                        highlight-current
                        :filter-node-method="filterNode"
                        ref="eltree"
                        default-expand-all
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  class="nodeRoot" >
                     
                     <span  style="font-size:14px; color:#409efe"><i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:18px;"></i>{{ node.label}} </span>
                    </span>                  
                    <span v-else > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;"></i> {{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
        </template>  
        <template slot="paneR">         
                <div class="tree-container">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool"  @click="addDept" :underline="false" ><span style="font-size:12px;margin-right:15px;">新增部门</span></el-link>
                    <i class="iconfont  icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>    
                    <el-link :disabled="editBool" @click="editDept" :underline="false" ><span style="font-size:12px;margin-right:15px;">编辑部门</span></el-link>
                    <i class="iconfont  icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>    
                    <el-link :disabled="delBool"  @click="delDept" :underline="false" ><span style="font-size:12px;margin-right:15px;">删除部门</span></el-link>
 
                    <el-tag effect='plain' style="margin-right:5px; margin-left:40px;">图形方向:</el-tag>
                    <el-radio-group v-model="orgval" size="small"  @change="toggleOrg">
                        <el-radio label="水平方向" border></el-radio>
                        <el-radio label="垂直方向" border></el-radio>
                    </el-radio-group>
                        
                </div>
                <div class="treeCss"  id="tree" ref="treeContainer">
                    <TreeChart 
                    :json="treeData"
                    :class="{landscape: isVertical}"
                    :isDetail="isDetail"
                    />
                </div>
                <el-dialog :visible.sync="addModal" width="700px" append-to-body :show-close="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{type==='create'?'新增部门':'编辑部门'}}</span>
                    </div> 
                    <Form ref="addForm" :model="formCol" :label-width="120"    label-position="right" inline >
                        <span v-for="(item,index) in tabCol" :key="index" >
                            <FormItem  style="color:red" :label="item.FLDNM" :prop="item.FLDNO" v-if="item.FHIDE==='N'">                                  
                                <Input type="text" :disabled="item.DISABLED==='Y'?true:false" v-model="formCol[item.FLDNO]"  style="width:190px;" clearable/>
                            </FormItem>
                        </span>
                    </Form>                     
                    <div slot="footer">
                        <Button type="primary"   @click="addModal=false" style="margin-right:50px;">取消</Button>
                        <Button type="primary"   @click="modal_ok">确定</Button>
                    </div>
                </el-dialog>
        </template>
        <el-dialog :visible.sync="dialogVisible" width="450px" append-to-body :show-close="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </split-pane> 
    
</template>

<script>
  import TreeChart from '@/components/TreeData'
  import { getTabColOrData,getBaseData } from '../../api/user'
  export default {
    name: 'hr_organize',
    components: {
      TreeChart
    },
    data() {
      return {
        treeData:{}, //图形树结构数据 
        dialogVisible:false,
        prompt:'',
        addModal:false, //modal 
        formCol:{}, //表格单行记录 model
        orgData:[] , //树结构数据
        defaultProps: {  //el-tree 默认字段属性
            children: 'children',
            id:'id',
            icon:'icon',
            parentid:'',
            label: 'label'
        },
        ruleValidate:{}, //校验规则
        type: 'create',
        nodeLabel:this.$cookies.get('v_corpnm'),
        treeid :'0',
        parentid:'',
        isVertical: false, // 是否是竖方向,只给最外层的添加
        isDetail: true, // 是否是详情,不可编辑操作
        orgval:'水平方向',
        tabCol:[] ,//表列集合
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        
      }
    },
    created () {
      if (this.v_username){
            this.getData()  
            this.getTabCol() // []
      }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
 
    },
    mounted () {
        //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','4190','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
    },
    computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 90) + 'px';
            },
            
        },
    methods: {
        //确定 保存
        modal_ok(){
            var vm=this;
            //发起保存请求   
            if (this.formCol['CNAME']){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(vm.formCol,{corpid:this.v_corpid})), p_table:'hr_frame'},
                }).then(res=>{      
                    if(res.result =='OK')  {          
                        vm.addModal =false   
                        vm.getData()       
                    }else{
                        this.$Message.error(res.result)
                    }        
                }) 
            }else{
                this.dialogVisible=true
                this.prompt='子名称不能为空'
            }
        } ,
        editDept(){
            if (this.treeid ==='0'){
                this.prompt='根节点不能修改'
                this.dialogVisible=true
            }else{
                this.addModal =true
                this.type ='edit'
                this.formCol ={}
                this.formCol['PARENTNO'] =this.parentid
                this.formCol['CNAME'] =this.nodeLabel  
                this.formCol['CODE']=this.treeid
            }
        },
        //新增
        addDept(){
             
                this.addModal =true
                this.type ='create'
                this.formCol ={}
                this.formCol['PARENTNO'] =this.treeid
                this.formCol['PCNAME'] =this.nodeLabel   
                    
        },
        //获取表列头字段 ---数组，表单字段loop
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4190','lstseq','1','','','').then((res) => {
                vm.tabCol = res.result
            });
        },

        //切换方向  
        toggleOrg(){
            this.isVertical = !this.isVertical
        },
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.parentid=data.parentid
        },
        //删除部门
        delDept(){
            if (this.treeid ==='0'){
                this.prompt='根结点不能删除'
                this.dialogVisible=true
            }else{ 
                this.$Modal.confirm({
                        title: '删除确认',
                        content: '<p>你确定要删除此节点吗</p>',
                        onOk: () => {
                            //发起删除请求
                            var vm=this;
                            //选判断有没子节点
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/getBaseData',
                                data: {p_key:'parentno',p_value:this.treeid,p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_hr_frame'},
                            }).then(res=>{  
                                if (res.result.length===0){
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/delTabRec',
                                        data: {p_key:'code',p_value:this.treeid,p_table:'hr_frame'},
                                    }).then(res=>{      
                                        if(res.code =='200')  {           
                                            vm.getData()       
                                        }else{
                                            this.dialogVisible=true
                                            this.prompt=res.result
                                        }        
                                    }) 
                                }else{
                                    this.dialogVisible=true
                                    this.prompt='存在子节点,不能删除'
                                }
                            })
                        }
                    });
            }
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            console.log('corpid:'+this.v_corpid)
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_HR_FRAME',p_cond:' and ( corpid=\''+this.v_corpid+'\')'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.orgData =res.result;  
                    vm.treeData =res.result[0]
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                    
                    //console.log(JSON.stringify(res[0])) 
                } else{
                    vm.dialogVisible=true
                    vm.prompt=res.result
                }            
            })                            
        },
    }
  }
</script>
<style scoped>
 .siderCls{
     background:#fff;
     margin: 3px auto;
     width: 260px;
     min-width: 260px;
     max-width:260px;
     border-right: 2px solid #C0C4CC;
}
.tree-container{
    padding-left:5px; 
    width:100%;
    background:#fff;
    margin:2px auto ;
    margin-top:5px;
    overflow: auto;

}
.treeCss{
    padding-left:5px; 
    width:100%;
    background:#fff;
    margin:2px auto ;
    margin-top:5px;
   overflow:auto;
   height: calc(100vh - 130px);
}
.nodeLabel{
        font-size:12px;
        font-weight:500;
        padding-left:10px;
        color: black;
    }
.nodeRoot{
        width:20px;
        font-size:14px;
        font-weight:600;
    }  
.top{
        padding: 10px;
        background: rgba(0, 153, 229, .7);
        color: #fff;
        text-align: center;
        border-radius: 2px;
    }        
</style>
<style lang="less">
.el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
       .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
</style>
